import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

import './util/rxjs';

import { UserService } from './user/user.service';

@Injectable()
export class ManagerGuard  {
  constructor(private userService: UserService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.userService.user$.map(user => {
      if (!user.isManager) {
        this.router.navigate(['/people']);
        return false;
      }

      return true;
    });
  }
}


